var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65741 0C2.53291 0 0 2.53705 0 5.66667V28.3333C0 31.4629 2.53291 34 5.65741 34H27.6343C30.7588 34 33.2917 31.4629 33.2917 28.3333V5.66667C33.2917 2.53705 30.7588 0 27.6343 0H5.65741ZM4.56906 7.6058C4.56906 9.31531 5.86304 10.5646 7.45921 10.5646C9.05561 10.5646 10.3496 9.31531 10.3496 7.6058C10.3496 5.89654 9.05561 4.64584 7.45921 4.64584C5.86304 4.64584 4.56906 5.89654 4.56906 7.6058ZM23.4343 29.2205H28.4475V19.0933C28.4475 14.0917 25.4246 12.3857 22.6273 12.3857C20.0408 12.3857 18.2837 14.1067 17.7985 15.1148V12.846H12.9774V29.2205H17.9905V20.3428C17.9905 17.9757 19.4487 16.8245 20.9362 16.8245C22.3432 16.8245 23.4343 17.6383 23.4343 20.2771V29.2205ZM9.96566 12.8334V29.2079H4.95276V12.8334H9.96566Z",
    fill: "#FEFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.259ef18f94c2dd948b6c31c3da4c3ec4.svg";
export { ForwardRef as ReactComponent };